<header class="header">
  <section>
    <form *ngIf="dateFilter" [formGroup]="dateFilter" (submit)="onFilterSubmited()" class="dateFilterForm">

      <mat-form-field>
        <mat-label>Entrer une période</mat-label>
        <mat-date-range-input formGroupName="range" [rangePicker]="picker">
          <input matStartDate formControlName="fromStartDate" placeholder="Du" (focus)="picker.open()">
          <input matEndDate formControlName="toStartDate" placeholder="Au" (focus)="picker.open()">
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>

      <button mat-icon-button type="submit" color="primary" [disabled]="dateFilter.invalid" matTooltip="Filtrer">
        <mat-icon>
          search
        </mat-icon>
      </button>

      <button type="button" mat-icon-button color="primary" matTooltip="Effacer les dates" (click)="onResetFilters()">
        <mat-icon>
          clear
        </mat-icon>
      </button>
    </form>
  </section>
  <section>
    <button type="button" mat-raised-button color="primary" (click)="onPdfExportClicked()"
      [disabled]="!hasPreBillingArticles()">
      <mat-icon aria-label="File">insert_drive_file</mat-icon>
      {{ 'billing.pre-billing.new.export' | translate}}
    </button>
  </section>
</header>

<section *ngIf="isLoading">
  <mat-progress-bar class="progress-bar" mode="indeterminate" color="primary"></mat-progress-bar>
</section>

<main *ngIf="hasWarning()">
  <mat-expansion-panel class="warning" [expanded]="true">
    <mat-expansion-panel-header>
      <mat-panel-title>
        Attention
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="warning-body">
      <div *ngFor="let warning of preBillingBook.incompleteBillingDatas">
        <p>Commande {{warning.identifier}}:</p>
        <ul>
          <li *ngIf="!warning.hasArticle">Article manquant.</li>
          <li *ngIf="!warning.hasSchedule">Horaires manquants.</li>
          <li *ngIf="!warning.hasWaitingTime">Temps d'attente manquant.</li>
        </ul>
      </div>
    </div>
  </mat-expansion-panel>
</main>

<main *ngIf="hasNoBillingArticle()">
  <p>
    {{ 'billing.pre-billing.new.noArticle' | translate}}
  </p>
</main>

<main class="datatable-container" [class.hide]="!hasPreBillingArticles()">
  <div class="menuDisplayedColumns">
    <button mat-mini-fab color="primary" matTooltip="Préférences des colonnes" [matMenuTriggerFor]="menu">
      <mat-icon>list</mat-icon>
    </button>

    <mat-menu #menu="matMenu">
      <div cdkDropList (cdkDropListDropped)="drop($event)">
        <div *ngFor="let displayedColumn of displayedColumnsMenu" cdkDrag>
          <section class="menu-item" (click)="$event.stopPropagation()">
            <ng-container *ngIf="displayedColumn.editable">
              <mat-checkbox class="example-margin" [checked]="displayedColumn.selected"
                (change)="onSelectMenu($event,displayedColumn.name)">
                {{ 'billing.pre-billing.new.list.' + displayedColumn.name | translate }}
              </mat-checkbox>
            </ng-container>
          </section>
        </div>
      </div>
    </mat-menu>

  </div>

  <form [formGroup]="selectedColForm">
    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="code">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox formControlName="code">
            {{ 'billing.pre-billing.new.list.code' | translate}}
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let proForma">{{ proForma.code }}</td>
      </ng-container>


      <ng-container matColumnDef="quantity">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox formControlName="quantity">
            {{ 'billing.pre-billing.new.list.quantity' | translate}}
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let proForma">{{ proForma.quantity }}</td>
      </ng-container>

      <ng-container matColumnDef="senderStep">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox formControlName="senderStep">
            {{ 'billing.pre-billing.new.list.senderStep' | translate}}
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let proForma">{{ proForma.sender }} / {{proForma.concatSteps()}}</td>
      </ng-container>

      <ng-container matColumnDef="totalWaitingPrice">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'billing.pre-billing.new.list.totalWaitingPrice' | translate}}
        </th>
        <td mat-cell *matCellDef="let proForma">{{ proForma.totalWaitingPrice }} €</td>
      </ng-container>

      <ng-container matColumnDef="urgency">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox formControlName="urgency">
            {{ 'billing.pre-billing.new.list.urgency' | translate}}
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let proForma">{{ proForma.urgency }}</td>
      </ng-container>

      <ng-container matColumnDef="lot">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox formControlName="lot">
            {{ 'billing.pre-billing.new.list.lot' | translate}}
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let proForma">{{ proForma.lot }}</td>
      </ng-container>

      <ng-container matColumnDef="unitPrice">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'billing.pre-billing.new.list.unitPrice' | translate}}
        </th>
        <td mat-cell *matCellDef="let proForma">{{ proForma.unitPrice }} €</td>
      </ng-container>

      <ng-container matColumnDef="moment">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox formControlName="moment">
            {{ 'billing.pre-billing.new.list.moment' | translate}}
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let proForma">{{ proForma.priceType }}</td>
      </ng-container>

      <ng-container matColumnDef="totalPrice">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'billing.pre-billing.new.list.totalPrice' | translate}}
        </th>
        <td mat-cell *matCellDef="let proForma">{{ proForma.totalPrice }} €</td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let proForma; columns: displayedColumns;"></tr>
    </table>
    <mat-paginator showFirstLastButtons [pageSize]="PAGINATION_PAGE_SIZE">
    </mat-paginator>
  </form>

  <section class="total">
    <p>
      Total : {{preBillingBook?.totalPrice}} €
    </p>
  </section>
</main>